<template>
    <ui-modal
        title="Altera valor das unidades Reservadas"
        icon="fal fa-lock-alt"
        name="change-value-reserved-units">

        <div class="container-change-value-reserved-units">
            <div class="header">
                <div class="header-subtitle">Informe os novos valores para as reservas selecionadas</div>
            </div>

            <div v-for="(unit, index) in form.data.units" :key="index" class="body">
                <div class="body-input">
                    <div class="body-input-units">
                        {{ unitInfos(unit) }}
                    </div>

                    <div class="body-input-line-center" />

                    <div class="body-input-value-units">
                        <ui-input-money v-model="unit.value" group />
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="footer-input">
                    <ui-input
                        ref="password"
                        v-model="form.data.password"
                        :type="passwordType"
                        groupicon="fal fa-lock-alt"
                        group-icon-color="#C0C3D3"
                        group-icon-background="#F8F9FE"
                        label="Digite a senha:"
                        invertgroup
                    />

                    <div class="footer-input-icon" @click="openClosePassword">
                        <em v-if="passwordIcon" class="fal fa-eye" />

                        <em v-else class="fal fa-eye-slash" />
                    </div>
                </div>

                <div class="footer-button">
                    <ui-button
                        :disabled="!canSubmit"
                        :loading="load"
                        design="md success mw-150"
                        @click="updateHandler">
                        Confirmar
                    </ui-button>
                </div>
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from "@/components/ui/modal"
    import { uiButton } from '@/components/ui/buttons'
    import { uiInput, uiInputMoney } from '@/components/ui/form'

    import { launchDay } from '@/services/axios'

    import { currencyBRL } from '@/filters'

    const defaultFormData = () => ({
        units: [],
        password: ''
    })

    export default {
        name: 'ui-change-value-reserved-units-modal',

        components: {
            uiModal,
            uiButton,
            uiInput,
            uiInputMoney
        },

        filters: { currencyBRL },

        data() {
            return {
                form: {
                    data: { ...defaultFormData() }
                },
                load: false,
                availability: null,
                launchday_id: null,
                passwordIcon: true,
                passwordType: 'password'
            }
        },

        computed: {
            /**
             * Computed property que habilita ou desabilita o botão de salvar os novos valores
             * das unidades selecionadas
             */
            canSubmit() {
                return this.form.data.units &&
                    this.form.data.units.length &&
                    this.form.data.password
            }
        },

        created(){
            this.$root.$on('modal-open-change-value-reserved-units', payload => {
                this.form.data = { ...defaultFormData() }
                if (payload && payload.reserved_units && payload.availability) {
                    this.form.data.units = Object.values(payload.reserved_units).map(unit => {
                        unit.value = parseFloat(unit.cost)

                        return unit
                    })
                    this.availability = { ...payload.availability }
                    this.launchday_id = payload.launchday_id
                }
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-open-change-value-reserved-units')
        },

        methods: {
            /**
             * Define se deve ou não mostrar a senha inserida para o usuário
             */
            openClosePassword() {
                this.passwordIcon = !this.passwordIcon
                this.passwordType = this.passwordIcon ? 'password' : 'text'
            },
            /**
             * Formata os dados da unidade de acordo com o tipo de disponibilidade e retorna o label
             * resultante
             */
            unitInfos(unit) {
                // Constrói o label para a unidade de acordo com o tipo de disponibilidade
                let infos = this.availability && this.availability.type === 'vertical'
                    ? `${unit.number} - Torre ${unit.block} - Andar ${unit.floor}`
                    : `${unit.number} - Quadra ${unit.block}`
                infos += ` - ${this.$options.filters.currencyBRL(unit.cost)}`

                return infos
            },
            /**
             * Event handler que realiza a atualização das unidades selecionadas de acordo
             * com os novos valores definidos
             */
            updateHandler() {
                this.load = true
                launchDay.create(`updateUnits/${this.launchday_id}`, { ...this.form.data })
                    .then(response => {
                        if (response.data && response.data.msg) this.$toastr.s(response.data.msg)
                        this.$root.$emit('modal-close-change-value-reserved-units')
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error.data)
                    })
                    .finally(() => {
                        this.load = false
                    })
            }
        }

    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>